import { render, staticRenderFns } from "./Organization.vue?vue&type=template&id=c6e30b28"
import script from "./Organization.vue?vue&type=script&lang=js"
export * from "./Organization.vue?vue&type=script&lang=js"
import style0 from "./Organization.vue?vue&type=style&index=0&id=c6e30b28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports